import { applyMiddleware, createStore } from "redux";
import { persistReducer, persistStore } from "redux-persist";

import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";
import { composeWithDevTools } from "redux-devtools-extension";
import reducer from "./reducers";
import storage from "redux-persist/lib/storage";
import thunk from "redux-thunk";

//app store
const persistConfig = {
  key: "root",
  storage: storage,
  stateReconciler: autoMergeLevel2,
  blacklist: [],
};
const persistedReducer = persistReducer(persistConfig, reducer);
const debug = false;
const middleware = debug
  ? composeWithDevTools(applyMiddleware(thunk))
  : applyMiddleware(thunk);
export const store = createStore(persistedReducer, middleware);
export const persistor = persistStore(store);
